module.exports = __webpack_public_path__ + "static/media/AS.e0de4550.svg";